export default __webpack_public_path__ + "static/image-06-af215c3bda93cd4684e6c67a0f5412e1.png";